module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    style: ({
      minHeight: _vm.boxheight
    })
  }, _vm._l((_vm.pdfList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pdfList-box",
      on: {
        "click": function($event) {
          return _vm.pdfRouter(item)
        }
      }
    }, [_c('div', {
      staticClass: "left-layout"
    }, [_c('img', {
      staticClass: "icon-pdf-style",
      attrs: {
        "src": require('@/assets/icon/icon_pdf.png')
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pdf-desc"
    }, [_c('div', {
      staticClass: "pdf-name"
    }, [_vm._v(_vm._s(item.fileName))]), _vm._v(" "), _c('div', {
      staticClass: "pdf-size"
    }, [_vm._v(_vm._s(Math.round(item.fileSize / 1024)) + "KB")])])]), _vm._v(" "), _c('img', {
      staticClass: "icon-right-arrow-style",
      attrs: {
        "src": require('@/assets/icon/icon_right_arrow.png')
      }
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51af62fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/BoSolution/PdfList.vue
// module id = 1634
// module chunks = 8